// @ts-nocheck
import React, { Component, Fragment } from "react";
import Modal from "../../../modal/modal.component";
import { toast } from "react-toastify";
import "./GitLogModal.css";
import ApiService from "../../../../services/api.service";
import {LoaderService} from "../../../../services/loader.service";
import {apiUrlConfig} from "../../../../constants/apiUrlConfig";

class GitLogModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      logs: [],
      loadingLogs: false,
      selectedBranch: "local", // default branch
      nodeData: this.props.nodeData
    };
    this.apiService = ApiService.getInstance();
  }

  onChangeInput = event => {
    this.setState({ nodeData: { ...this.state.nodeData, name: event.target.value } });
  };

  loadGitLogs = async () => {
    this.setState({ loadingLogs: true });
    try {
      const { selectedBranch } = this.state;
      //const res = await this.apiService.git_fetchGitLog("/git/log", selectedBranch);
      LoaderService.show();
      const data = await this.apiService.get(apiUrlConfig.git_flow_log(selectedBranch));
      if (data.success && data.object) {
        const payload = data.object;
        const logs = Array.isArray(payload) ? payload : [];
        const formattedLogs = logs.map(log => ({
          commit: log.commit || "(no-hash)",
          author: `${log.author} <${log.email}>`,
          date: new Date(log.date).toLocaleString(),
          message: log.message
        }));
        this.setState({logs: formattedLogs, loadingLogs: false});
      }
    } catch (err) {
      toast.error("Failed to fetch Git logs.");
      this.setState({ loadingLogs: false });
    } finally {
      this.setState({ loadingLogs: false });
      LoaderService.hide();
    }
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [name]: value
      }
    }));
  };

  render() {
    return (
      <Modal>
        <Fragment>
          <div className="modal-dialog modal-add-activity-content">
            <div className="modal-content" style={{ padding: "20px" }}>
              <div
                className="modal-header"
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <h4 style={{ margin: 0 }}>
                  <span className="glyphicon glyphicon-lock" /> Git Log
                </h4>
                <button
                  type="button"
                  className="close"
                  onClick={this.props.close}
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    border: "none",
                    background: "transparent",
                    cursor: "pointer"
                  }}
                >
                  &times;
                </button>
              </div>

              <div style={{ marginBottom: "16px", marginTop: "10px" }}>
                <label htmlFor="branch-select" style={{ fontWeight: "bold", marginRight: "8px" }}>
                  Branch:
                </label>
                <select
                  id="branch-select"
                  value={this.state.selectedBranch}
                  onChange={e => this.setState({ selectedBranch: e.target.value })}
                  style={{
                    padding: "6px 10px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    minWidth: "120px"
                  }}
                >
                  <option value="local">local</option>
                  <option value="main">main</option>
                </select>
              </div>

              <div
                className="modal-body"
                style={{
                  maxHeight: "320px",
                  overflowY: "auto",
                  backgroundColor: "#f9f9f9",
                  padding: "10px",
                  borderRadius: "6px"
                }}
              >
                {this.state.loadingLogs ? (
                  <p>Loading Git logs...</p>
                ) : this.state.logs.length === 0 ? (
                  <p>No logs available.</p>
                ) : (
                  <pre style={{ whiteSpace: "pre-wrap", fontSize: "13px" }}>
                    {this.state.logs.map((log, index) => (
                      <div key={index} style={{ marginBottom: "16px" }}>
                        <strong>commit {log.commit}</strong>
                        <br />
                        Author: {log.author}
                        <br />
                        Date: {log.date}
                        <br />
                        <br />
                        &nbsp;&nbsp;{log.message}
                      </div>
                    ))}
                  </pre>
                )}
              </div>

              <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button
                    type="button"
                    className="btn btn-primary"  // Bootstrap primary button
                    onClick={() => this.loadGitLogs()}
                    disabled={this.state.loadingLogs}
                >
                  {this.state.loadingLogs ? 'Fetching...' : 'Fetch Logs'}
                </button>
              </div>
            </div>
          </div>
        </Fragment>
      </Modal>
    );
  }
}

export default GitLogModal;
